import Vue from "vue";
import Router from "vue-router";
import User from "./views/UsersPage.vue";
import Login from "./views/LoginPage.vue";
import Orders from "./views/OrdersPage.vue";
import OrderInfoPage from "./views/OrderInfoPage.vue";
import ProductsStatusChange from "./views/ProductStatusChangePage.vue";
import Company from "./views/CompanyPage.vue";
import Customers from './views/CustomersPage.vue';
import Trucks from './views/TrucksPage.vue'
import Pallets from './views/PalletsPage.vue';
import Scanner from './views/PalletScannerPage.vue';
import Home from './views/Home.vue';
import PalletingPage from './views/PalletingPage.vue';
import PackingType from './views/PackingTypesPage.vue';
import TruckScanner from './views/TruckScannerPage.vue';
import RedirectComponent from './views/RedirectComponent.vue';
import EditAccount from "./views/EditAccountPage.vue";
import WorkCentersPage from "./views/WorkCentersPage.vue";
import WorkCenterPlanPage from "./views/WorkCenterPlanPage.vue";
import ProductionPlanningPage from "./views/ProductionPlanningPage.vue";
import ProblemsPage from "./views/ProblemsPage.vue";
import PalletInfoPage from "./views/PalletInfoPage.vue";
import GlassUnitsPage from "./views/GlassUnitsPage.vue";
import WorkCentersManagementPage from "./views/WorkCentersManagementPage.vue";
import ProductSetPage from "./views/ProductSetPage.vue";
import ToolsPage from "./views/ToolsPage.vue";
import PreperationPage from "./views/PreperationPage.vue";
import PreperationPage1 from "./views/PreperationPage1.vue";
import SupplierPage from "./views/SupplierPage.vue";
import PdfTemplatesPage from "./views/PdfTemplatesPage.vue";
import test from "./views/test.vue";
import { i18n } from "./main.js";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: RedirectComponent
    },
    {
      path: '/:lang',
      name: 'home',
      component: Home,
      beforeEnter(to, from, next){
        const lang = to.params.lang;

        if(!['en', 'lt'].includes(lang)) return next('lt');

        if(i18n.locale !== lang){
          i18n.locale = lang;
        }
        return next();
      },
      children: [
        {
          path: 'user',
          name: 'user',
          component: User
        },
        {
          path: 'login',
          name: 'login',
          component: Login
        },
        {
          path: 'orders/:filter?/:delivery_date_from?/:delivery_date_to?/:status_from?/:status_to?/:per_page?/:page?/:order_by?/:order?',
          name: 'orders',
          component: Orders
        },
        {
          path: 'products/:id',
          name: 'products',
          component: OrderInfoPage
        },
        {
          path: 'status-change',
          name: 'status-change',
          component: ProductsStatusChange
        },
        {
          path: 'company',
          name: 'company',
          component: Company
        },
        {
          path: 'customers/:filter?',
          name: 'customers',
          component: Customers
        },
        {
          path: 'trucks-list/:filter?/:delivery_date_from?/:delivery_date_to?/:status_from?/:status_to?/:page?/:order_by?/:order?',
          name: 'trucks-list',
          component: Trucks
        },
        {
          path: 'pallets/:filter?/:status_from?/:status_to?/:page?/:order_by?/:order?',
          name: 'pallets',
          component: Pallets
        },
        {
          path: 'scanner',
          name: 'scanner',
          component: Scanner
        },
        {
          path: 'truck-scanner/:truck',
          name: 'truck-scanner',
          component: TruckScanner
        },
        {
          path: 'packing-types',
          name: 'packing-types',
          component: PackingType
        },
        {
          path: "edit-account",
          name: "edit-account",
          component: EditAccount
        },
        {
          path: 'pallet-planning/:filter?',
          name: 'pallet-planning',
          component: PalletingPage
        },
        {
          path: "work-centers",
          name: "work-centers",
          component: WorkCentersPage
        },
        {
          path: "work-center/:id",
          name: "work-center",
          component: WorkCenterPlanPage
        },
        {
          path: "production",
          name: "production",
          component: ProductionPlanningPage
        },
        {
          path: "problems",
          name: "problems",
          component: ProblemsPage
        },
        {
          path: "pallet-info/:id",
          name: "pallet-info",
          component: PalletInfoPage
        },
        {
          path: "glass-units/:filter?",
          name: "glass-units",
          component: GlassUnitsPage
        },
        {
          path: "work-centers-management",
          name: "work-centers-management",
          component: WorkCentersManagementPage
        },
        {
          path: "product-set/:barcode?",
          name: "product-set",
          component: ProductSetPage
        },
        {
          path: "tools",
          name: "tools",
          component: ToolsPage
        },
        {
          path: "preperation",
          name: "preperation",
          component: PreperationPage
        },
        {
          path: "preperation1",
          name: "preperation1",
          component: PreperationPage1
        },
        {
          path: "suppliers",
          name: "suppliers",
          component: SupplierPage
        },
        {
          path: "pdf-templates",
          name: "pdf-templates",
          component: PdfTemplatesPage
        },
        {
          path: "test",
          name: "test",
          component: test
        }
      ]
    },
  ]
});
